export default __webpack_public_path__ + "static/media/BumpBoxes_Registry_ClosedBox.67bbd14d.png";